// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { BaseItem, ColumnData } from '../BaseItem';
import { ColumnParams } from '../ColumnParams';
import { QuickTableEditingInfo } from '../../elements/QuickTable/QuickTableMisc';
import { DynProperty } from '@shared/commons/DynProperty';
import { TableTotalsVisibility } from '../TableTotalsVisibility';
import { QTAlignment } from '../../elements/QuickTable/QuickTableColumn';
export class IndicatorsManagerItem extends BaseItem {
    constructor(renderer) {
        super();
        this.Renderer = renderer;
        const visibilityButton = new QuickTableEditingInfo(DynProperty.VISIBILITY_BUTTON);
        visibilityButton.TooltipKey = 'ObjectManagerItem.Visible.ToolTip';
        this.QuickTableEditingInfoMap[IndicatorsManagerItem.VISIBLE_COL_INDEX] = visibilityButton;
        const settingsButton = new QuickTableEditingInfo(DynProperty.SETTINGS_BUTTON);
        settingsButton.TooltipKey = 'ObjectManagerItem.Settings.ToolTip';
        this.QuickTableEditingInfoMap[IndicatorsManagerItem.SETTINGS_COL_INDEX] = settingsButton;
        const closeButton = new QuickTableEditingInfo(DynProperty.CLOSE_BUTTON);
        closeButton.TooltipKey = 'ObjectManagerItem.Remove.ToolTip';
        this.QuickTableEditingInfoMap[IndicatorsManagerItem.REMOVE_COL_INDEX] = closeButton;
    }
    getItemSubject() {
        return this.Renderer;
    }
    ColumnCount() {
        return IndicatorsManagerItem.columnsParams.length;
    }
    GetColumnParams(i) {
        const par = IndicatorsManagerItem.columnsParams[i];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    GetMenuIndex(headerKey) {
        if (IndicatorsManagerItem.ListMenuIndex[headerKey]) {
            return IndicatorsManagerItem.ListMenuIndex[headerKey];
        }
        else {
            return 1000;
        }
    }
    getColumnValue(column) {
        const indicator = this.Renderer.Indicator;
        switch (column) {
            case IndicatorsManagerItem.NAME_COL_INDEX:
                return indicator.ShortName();
            case IndicatorsManagerItem.WINDOW_COL_INDEX:
                if (this.Renderer.WindowsNumber === 0) {
                    return Resources.getResource('ChartObjectManager.mainWindow');
                }
                else {
                    return `${Resources.getResource('ChartObjectManager.subWindow')} ${this.Renderer.WindowsNumber}`;
                }
            case IndicatorsManagerItem.VISIBLE_COL_INDEX:
                return this.Renderer.Visible;
            default:
                return '';
        }
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        let FormattedValue = null;
        switch (column) {
            case IndicatorsManagerItem.NAME_COL_INDEX:
                FormattedValue = value;
                break;
            case IndicatorsManagerItem.WINDOW_COL_INDEX:
                FormattedValue = value;
                break;
        }
        return new ColumnData(value, FormattedValue);
    }
}
IndicatorsManagerItem.NAME_COL_INDEX = 0;
IndicatorsManagerItem.WINDOW_COL_INDEX = 1;
IndicatorsManagerItem.VISIBLE_COL_INDEX = 2;
IndicatorsManagerItem.SETTINGS_COL_INDEX = 3;
IndicatorsManagerItem.REMOVE_COL_INDEX = 4;
IndicatorsManagerItem.columnsParams = [
    new ColumnParams('ObjectManagerItem.Name', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Window', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Visible', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Settings', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Remove', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false)
];
IndicatorsManagerItem.ListMenuIndex = [
    'ObjectManagerItem.Name',
    'ObjectManagerItem.Window',
    'ObjectManagerItem.Visible',
    'ObjectManagerItem.Settings',
    'ObjectManagerItem.Remove'
];
